import { Link, useLocation, useParams } from "react-router-dom";
import { UserProfileInline } from "app/components/UserProfileInline";
import { AlertMessage } from "app/components/AlertMessage";
import { Label } from "app/components/Label";
import moment from "moment";



export const UserBookListItem = ({ userBook }) => {

    const location = useLocation();
    const { school } = useParams();

    return (
        <li className="col-3 col-xl-4 col-lg-6 col-sm-12">
            <Link to={`/${school}/userbook/view/${userBook.id}${location.search}`}>
                <div className={`card-list bg-white ${userBook.creative === "Y"?'creative':''} ${userBook.completed?'completed':''} ${userBook.deleteYn === "Y" ? "deleteContainer" : ""}`}>
                    <div className="etc">
                        {userBook.creative === "Y" && <div className="ribbon creative"> <span>창작</span> </div>}
                        {userBook.keepCheck && <div className="ribbon red"> <span>찜❤</span> </div>}
                    </div>

                    <div className="card-head">
                        <AlertMessage type="delete" text="삭제됨" visible={userBook.deleteYn === "Y"} />
                        <UserProfileInline
                            id={userBook.userId}
                            name={userBook.userName}
                            type={userBook.userType}
                            school={userBook.schoolName}
                            image={userBook.userImage}
                            className="sm" />
                    </div>

                    <div className="card-section">
                        <div>
                            <div className="card-image">
                                {moment().diff(moment(userBook.updatedAt), "days") < 1 && <Label semantic="error" emphasis="light" size="xs">새 작품</Label>}
                                {userBook.image !== null && userBook.image !== "" && <img src={userBook?.image} alt={userBook.subject} />}
                                {(userBook.image === null || userBook.image === "") && (<img src={`${process.env.PUBLIC_URL}/static/images/userbook/userbook_cover_no_image.jpg`} alt="표지 없음" />)}
                            </div>
                            <div className="title">
                                <p>{userBook?.completed&&<strong className="completed-text">[완]</strong>} {userBook.subject}</p>
                            </div>
                        </div>
                    </div>

                    <div className="card-footer">
                        <div className="count">
                            <span className="episodeCount">
                                <i className="fa-solid fa-book"></i>{userBook.episodeCount}
                            </span>
                            <span className="keepCount">
                                <i className="fa-regular fa-heart"></i>{userBook.keepCount}
                            </span>
                        </div>
                        <div className="date">
                            <span><i className="fa-regular fa-clock"></i>{moment(userBook.updatedAt).format("LL")}</span>
                        </div>
                    </div>
                </div>
            </Link>
        </li>
    );

};